module.exports = __webpack_public_path__ + "img/special-01.ac459e53.png";